<template>
  <div class="cnt-section bg-gradient campaigns-section">
    <div class="container p-l-30 p-r-30">
      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center flex-column flex-md-row m-b-40">
          <h4 class="section-title text-white mb-0">Latest campaigns
            <span class="d-block font-20">Invest in the movers and shakers that are raising funds with payAngel </span>
          </h4>
          <a class="btn btn-gunmetal text-uppercase btn-lg btn-mw" href="/campaign/all">View All
            Campaigns</a>
        </div>
      </div>
      <div class="row row-deck" v-if="campaigns && campaigns.length > 0">
        <div class="col-xl-4 col-lg-6 col-md-6" v-for="(campaign, index) in campaigns" :key="index">
          <div class="campaigns-box">
            <div class="campaigns-img">
              <!-- TODO: Uncomment this once issue of 404 is fixed -->
              <img class="d-none" :src="imagePath(campaign.image)" @error="errorimg(campaign.image)">
              <div class="circular" v-if="campaign.imagefound == false" :style="{ 'background-image': `url(${require('@/assets/images/events--no-img.png')})` }"></div>
              <div class="circular" v-else :style="imagePathWithImageValid(campaign.image)"></div>
            </div>
            <div class="campaigns-cnt">
              <h6 class="campaigns-title">{{ campaign.title }}</h6>
              <!-- <p class="desp" v-html="campaign.description"></p> -->
              <ul class="list-unstyled my-4 campaigns-details">
                <template v-if="campaign.location.length">
                  <li v-if="campaign.location && campaign.location[0]">
                    <label class="text-uppercase">Raised: </label>
                    <span class="ml-1" :class="campaign.location[0].target_currency"></span>
                    {{ campaign.campaign_id == '1de2a03f-3ff8-4fa7-85ac-2d4c874c45b4' ? ' -- ' : convertCurrencyFormat(campaign.total_donation) }}
                  </li>
                  <li v-if="campaign.location && campaign.location[0] && campaign.location[0].is_target_amount">
                    <label class="text-uppercase">Target: </label>
                    <span class="ml-1" :class="campaign.location[0].target_currency"></span>
                    {{ convertCurrencyFormat(campaign.location[0].target_amount) }}
                  </li>
                </template>
                <template v-else>
                  &nbsp;
                </template>
              </ul>
              <router-link :to="{ name: 'campaign', params: { campaign_id: campaign.slug } }"
                class="btn btn-outline-white text-uppercase mr-3 btn-lg btn-mw campaign-btn-50">Details</router-link>
              <template
                v-if="(campaign && campaign.location[0] && campaign.location[0].is_open_ended == true) || ((campaign && campaign.location[0] && campaign.location[0].is_open_ended == false) && momentObj(campaign.location[0].end_date + ' 23:59:59').isAfter(momentObj()))">
                <router-link v-if="campaign.categories.length > 0"
                  :to="{ name: 'campaign-donate', params: { campaign_id: campaign.slug } }"
                  class="btn btn-white-orange text-uppercase btn-lg btn-mw campaign-btn-50">Donate</router-link>
                <button v-else class="btn btn-white-orange text-uppercase btn-lg btn-mw campaign-btn-50"
                  @click="openDonateModal(campaign)">Donate</button>
              </template>
              <template v-else>
                <span v-b-tooltip.hover title="Campaign is ended">
                  <button class="btn btn-white-orange text-uppercase btn-lg btn-mw campaign-btn-50" disabled>
                    Donate</button>
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row row-deck">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="campaigns-box w-100 mt-0">
            <div class="campaigns-cnt w-100 mt-0">
              <div class="title-area w-100 text-center">
                <h6 class="campaigns-title pb-1">Create Your Campaign Today</h6>
                <p class="text-white w-50 mx-auto">Easily set up a fundraiser or a group contribution campaign to
                  pool funds together from your members and well-wishers for that impactful project, special goal or
                  social support project</p>
                <router-link to="/authentication/register"
                  class="btn btn-outline-dark-orange text-uppercase btn-lg btn-mw bg-white">Let's create</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <h4 v-else class="text-center text-white">No Campaign Found</h4> -->
    </div>
    <donate-modal-component :campaign="campaignData" :sliderOptions="donateSliderOptions"
      :amountOptions="amountOptionsList" :tipOptions="donateTipOptions" :amountTotal="donateTotalAmount"
      :buttonList="donateButtonList">
    </donate-modal-component>
  </div>
</template>
<script>
const moment = require('moment');
export default {
  name: "UpcommingCampaignsComponent",
  components: {
    'donate-modal-component': () => import("@/components/frontend/campaign/DonateAmountModal.vue"),
  },
  props: {
    campaigns: [Array, Object]
  },
  data() {
    return {
      isValidImage: null,
      campaignData: [],
      momentObj: moment
    }
  },
  methods: {
    errorimg(image){
      this.campaigns.map((item) => {
        if(item.image == image){
          item.imagefound = false;
        }
      });
    },
    imagePath(image) {
      return `${process.env.VUE_APP_BASE}${image}`
    },
    imagePathWithImageValid(image) {
      // if (typeof image != 'object') {
        // image = `${process.env.VUE_APP_BASE}${image}`;
      //   const img = new Image();
      //   img.src = image;
      //   if (img.complete) {
      //     this.isValidImage = true
      //   } else {
      //     img.onload = () => {
      //       this.isValidImage = true
      //     };
      //     img.onerror = () => {
      //       this.isValidImage = false
      //     };
      //   }
      //   console.log(image,this.isValidImage);
      //   if (this.isValidImage != null) {
      //     if (this.isValidImage) {
            return { 'background-image': `url(${process.env.VUE_APP_BASE}${image})` }
      //     } else {
      //       return { 'background-image': `url(${require('@/assets/images/events--no-img.png')})` }
      //     }
      //   }
      // } else {
      //   return { 'background-image': `url(${require('@/assets/images/events--no-img.png')})` }
      // }
    },
    openDonateModal(data) {
      this.campaignData = data;
      var amountTotal = 0

      var sliderOptions = {
        percentageValue: 0, //1,
        min: 0,
        max: 5
      }

      var buttonList = [
      //   {
      //     class: 'btn btn-lg mb-3',
      //     amount: 1000,
      //     active: false
      //   },
      //   {
      //     class: 'btn btn-lg mb-3',
      //     amount: 2000,
      //     active: false
      //   },
      //   {
      //     class: 'btn btn-lg mb-3',
      //     amount: 3000,
      //     active: false
      //   },
      //   {
      //     class: 'btn btn-lg mb-3',
      //     amount: 4000,
      //     active: false
      //   }
      ]

      var amountOptions = {
        customAmount: null
      }

      var tipOptions = {
        customtipAmount: '',
        showCustomTipTextBox: false
      }

      if(data.location && data.location[0] && data.location[0].is_suggested_funding) {
        data.location[0].suggested_funding_options.map((item) => {
            buttonList.push({amount: item, active: false})
        })
        this.$store.commit('setButtonList', buttonList)
      }else{
        this.$store.commit('setButtonList', [])
      }

      this.$store.commit('setAmountOptions', amountOptions)
      this.$store.commit('setAmountTotal', amountTotal)
      
      this.$store.commit('setTipOptions', tipOptions)
      this.$store.commit('setSliderOptions', sliderOptions)
      this.$bvModal.show('donate');
    }
  },
  computed: {
    donateSliderOptions() {
      return this.$store.getters.getSliderOptions;
    },

    amountOptionsList() {
      return this.$store.getters.getAmountOptions;
    },

    donateTipOptions() {
      return this.$store.getters.getTipOptions;
    },

    donateTotalAmount() {
      return this.$store.getters.getAmountTotal;
    },

    donateButtonList() {
      return this.$store.getters.getButtonList;
    }
  },
};
</script>
